import { TransportPlannerProfileListFacade } from '../state/monitoring/transport-planner-profile';
import { TransportManagementProfileListFacade } from '../state/monitoring/transport-management-profile';

export type PlannerProfileListFacade = TransportPlannerProfileListFacade | TransportManagementProfileListFacade;
